import {
    Button,
    IconButton,
    makeStyles,
    useMediaQuery,
    withStyles,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import FilterListIcon from '@material-ui/icons/FilterList';
import React from 'react';
import styles from '../css/filter.module.css';
import '../css/main.css';
import CheckBoxFilter from './CheckBoxFilter';
import DepartmentSelector from './DepartmentSelector';
import PriceSlider from './PriceSlider';
import SearchBar from './SearchBar';

const useStyles = makeStyles({
    close: {
        position: 'fixed',
        top: 2,
        right: 2,
        zIndex: 1300,
        color: 'var(--white)',
    },
});

const FilterButton = withStyles({
    root: {
        color: 'var(--grey)',
        backgroundColor: 'var(--side-color)',
        fontFamily: 'Open Sans',
        fontWeight: 700,
        textTransform: 'none',
        marginLeft: '1.1rem',
        marginBottom: '1rem',
        fontSize: '1.1rem',
        padding: '.5rem .8rem',
    },
})((props) => <Button {...props} />);

const Filter = (props) => {
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const handleFilterToggle = () => {
        setMobileOpen(!mobileOpen);
        document.body.classList.toggle('frozen');
    };
    const isSmall = useMediaQuery('(max-width: 900px)');
    const classes = useStyles();

    const filters = (
        <div className={styles.bg}>
            <SearchBar />
            <DepartmentSelector />
            <CheckBoxFilter />
            <div className={styles.sliders}>
                <PriceSlider />
            </div>
        </div>
    );
    return (
        <div>
            {isSmall ? (
                <div>
                    <FilterButton onClick={handleFilterToggle}>
                        <FilterListIcon style={{ marginRight: '.5rem' }} />{' '}
                        Filter
                    </FilterButton>
                    {mobileOpen && (
                        <>
                            <div>{filters}</div>
                            <IconButton
                                className={classes.close}
                                aria-label="close"
                                onClick={handleFilterToggle}
                            >
                                <CloseIcon fontSize="large" />
                            </IconButton>
                        </>
                    )}
                </div>
            ) : (
                <div>{filters}</div>
            )}
        </div>
    );
};

export default Filter;
